import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Prefer env vars in production builds. Fallbacks keep local/dev working.
// Restrict this browser API key in Google Cloud (HTTP referrers).
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDe7-cEpO0aL_GpCJeFZCafz5e4o3EHZiY",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "ezcarrental-prod.firebaseapp.com",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://ezcarrental-prod-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "ezcarrental-prod",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "ezcarrental-prod.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1080956829194",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:1080956829194:web:797d0cac6d8d7c51fe69f3",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-W99BGF6M2N",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
